module.exports = __webpack_public_path__ + "img/palm2_6.b6cb97e0.png";